import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import { PRODUCT_TYPE_OPTIONS } from "../../../constants"
import { AssociateProductType } from "../../../types"

import CompetitorProductSearchSuggestion from "@/components/SearchSuggestion/CompetitorProductSearchSuggestion"
import ProductSearchSuggestion from "@/components/SearchSuggestion/ProductSearchSuggestion"
import { AerosSelect } from "@/components/UiKit/AerosSelect"
import type { AutocompleteOption } from "@/types/form-fields"

// Style constants for search bar components
const productTypeSelectorStyles = {
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: "4px 0 0 4px",
  },
}

const searchInputStyles = {
  marginLeft: "-1px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: "0 4px 4px 0",
  },
}

interface ProductSearchBarProps {
  productType: AssociateProductType
  onTypeChange: (type: AssociateProductType) => void
  onSearchChange: (searchedItem: string | AutocompleteOption) => void
}

/**
 * Product search bar with type selector and search input
 * Allows switching between Akrochem and Competitor product types
 */
export const ProductSearchBar: FC<ProductSearchBarProps> = ({ productType, onTypeChange, onSearchChange }) => {
  return (
    <Box className='flex flex-col gap-3'>
      <Typography className='text-ml font-normal text-gray-900'>
        Search Products to create Equivalent Association
      </Typography>

      <Box className='flex w-[920px] items-start gap-0'>
        <AerosSelect
          value={productType}
          onChange={(value) => value && onTypeChange(value)}
          options={PRODUCT_TYPE_OPTIONS}
          size='small'
          sx={productTypeSelectorStyles}
        />
        {productType === AssociateProductType.Akrochem ? (
          <ProductSearchSuggestion onSearch={onSearchChange} sx={searchInputStyles} />
        ) : (
          <CompetitorProductSearchSuggestion onSearch={onSearchChange} sx={searchInputStyles} />
        )}
      </Box>
    </Box>
  )
}
